import { render, staticRenderFns } from "./IntegrationsSubmitApiCredentials.vue?vue&type=template&id=ca481588&scoped=true&"
import script from "./IntegrationsSubmitApiCredentials.vue?vue&type=script&lang=js&"
export * from "./IntegrationsSubmitApiCredentials.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsSubmitApiCredentials.vue?vue&type=style&index=0&id=ca481588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca481588",
  null
  
)

export default component.exports